{
  "confirmPassword": "Repeat the new password",
  "loginNow": "Sign in now",
  "newPassword": "New password",
  "noToken": "This link is incomplete. Open the link from the email again.",
  "passwordMismatch": "The passwords do not match.",
  "submit": "Set password",
  "successMessage": "You can sign in with your new password now. Taking you to sign-in…",
  "successTitle": "Password changed",
  "title": "Choose a new password"
}
